/* eslint-disable no-unused-vars */
import React, {  useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import "./login.css";
//import BackgroundImage from "../../imagen/background.jpg";
import BackgroundImage from "../../imagen/fondo_login.jpg";
import Logo from "../../imagen/agricoLogo.jpg";
import api from '../api/axio';
import  useFetch  from '../api/useFetch'
import  useFetchSuc  from '../api/useFetch'
import Cookies from 'universal-cookie';

function Login()  { 
  const { data: empresa, isLoading, error } = useFetch("Empresas");
  //const { data: sucursal,isLoading: isLoadingSucursal, error:errorSucursal } = useFetchSuc("Sucursales");
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    await delay(500);
    const DatosLogin = {
      usuario: inputUsername,
      contrasena: inputPassword
    };

    setShow(false);
    
    try {
      const response = await api.post('/ValidaLogin/login', DatosLogin);
      
      const usuarios = response?.data || [];

      if (Array.isArray(usuarios) && usuarios.length > 0) {
        const user = usuarios[0];
        // Guardar datos en localStorage
        if (user.id_Usuario) {
          localStorage.setItem('idUsuario', user.id_Usuario); 
          localStorage.setItem('id_Usuario', user.id_Usuario); 
        }
        if (user.nb_UsuarioCompleto) localStorage.setItem('nb_UsuarioCompleto', user.nb_UsuarioCompleto);
        if (user.id_Empleado) localStorage.setItem('id_Empleado', user.id_Empleado);
        if (user.nb_Usuario) localStorage.setItem('nb_Usuario', user.nb_Usuario);
        if (user.de_Correo) localStorage.setItem('de_Correo', user.de_Correo);
        // Cambiar a navegación programática en lugar de reload
        window.location.href = '/';
      } else {
        console.log('No se encontraron usuarios válidos');
        setShow(true);
      }
    } catch (error) {
      console.error('Error en login:', error);
      //console.error('Error response:', error.response?.data);
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePassword = () => {};

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <div
      className="sign-in__wrapper"
      style={{  backgroundImage: `url(${BackgroundImage})` }}>
      {/* Overlay */}
      <div className="sign-in__backdrop"></div>
      {/* Form */}
      <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
        {/* Header */}
        <img  className="img-thumbnail mx-auto d-block mb-2" style={{width: '250px', height: 'auto'}}  src={Logo} alt="LogoChada"
        />
          {empresa && empresa.map((i) => (
          <div key={i.id_Empresa} className="h4 mb-2 text-center">{i.nb_Empresa}</div>
        ))}
        {/* ALert */}
        {show ? (
          <Alert className="mb-2"  variant="danger" onClose={() => setShow(false)}  dismissible>
             usuario o contraseña incorrecta!!.
          </Alert>
        ) : (
          <div />
        )}
        <Form.Group className="mb-2" controlId="username">
          <Form.Label>Usuario</Form.Label>
          <Form.Control
            type="text"
            value={inputUsername}
            placeholder="Usuario"
            onChange={(e) => setInputUsername(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="password">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            value={inputPassword}
             spellCheck={false}
            placeholder="Contraseña"
            onChange={(e) => setInputPassword(e.target.value)}
            required
          />
        </Form.Group>
        {/**<Form.Group className="mb-2" controlId="Sucursal">
          <Form.Label>Sucursales</Form.Label>
          <Form.Select  >
          <option value="-1">Seleccionar</option>  
          {sucursal?.map((suc) => (
          <option  key={suc.id_Sucursal} >{suc.nb_Sucursal}</option>
        ))}
          </Form.Select>
        </Form.Group> */}
        
        {!loading ? (
          <Button className="w-100" variant="primary" type="submit">
            iniciar
          </Button>
        ) : (
          <Button className="w-100" variant="primary" type="submit" disabled>
            Logging In...
          </Button>
        )}
      
      </Form>
      {/* Footer */}
      <div className="w-100 mb-2 position-absolute bottom-0 start-50 translate-middle-x text-white text-center">
        SIAGRI &copy;2024
      </div>
    </div>
  );
};

export default Login;
